import { atom } from 'jotai';

export const isBannerClosedAtom = atom(true);
